import { getCQActionNameByCode } from "@bitComponents/telcovid/CommonUtils";
import { isNumber } from '@bitComponents/utils/common';
import { PRODUCT_TYPES } from "../../utils/catalog";
import { STRING_KEYS } from "../../localizedStrings/index";
import { CHARACTERISTIC_VALUES, CQ_ACTION_CODES, CQ_POTS } from "../../catalogConstants";
import { FLOW_TYPES } from "../../flowDefinition/flowTypes";

const getErrorSection = (error, localizedStrings) => {
  let message = "";
  if (error) {
    const { code, description } = { ...error };
    const title = "::::::::::::: INFORMACIÓN ERROR TELCO :::::::::::::\n";
    if (code) {
      message = `${message}${
        localizedStrings[STRING_KEYS.se.message.error.title]
      } : ${code}\n`;
    }
    if (description) {
      message = `${message}${
        localizedStrings[STRING_KEYS.se.message.error.description]
      } : ${description}\n`;
    }
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getProductSection = (buyInfo, r2rInfo) => {
  let message = "";

  if (buyInfo) {
    const {
      productName,
      productOffering,
      promotion,
      promotionName,
      price,
      priceRecurring,
      mainAction,
      secondarySelection,
      flowName,
      r2rType,
      r2rSubType,
      isPrePurchase,
      color,
    } = { ...buyInfo };
    const title = ":::::::::::::DATOS DEL PRODUCTO:::::::::::::\n";

    if (r2rInfo && r2rInfo.length > 1 && flowName === FLOW_TYPES.PACK_R2R) {
      const firstR2R = r2rInfo[0];
      if (firstR2R.r2rName) {
        message = `${message}Producto Destino : ${firstR2R.r2rName}\n`;
      }
      if (firstR2R.color) {
        message = `${message}Color : ${firstR2R.color}\n`;
      }
      if (firstR2R.poId) {
        message = `${message}ID Producto Destino : ${firstR2R.poId}\n`;
      }
      if (isNumber(firstR2R.price)) {
        message = `${message}Precio producto : ${firstR2R.price} €/mes\n`;
      }
       /*
        Operación comercial : ALTA
Descripción del Producto : packR2R
Tipo R2R : adicional
       */
      message = `${message}Operación comercial : ALTA\n`;
      message = `${message}Descripción del Producto : ${flowName}\n`;

      if(isPrePurchase !== undefined){
        message = `${message}Precompra : ${isPrePurchase ? `Si` : 'No'}\n`;
      }

      if (firstR2R.r2rType) {
        message = `${message}Tipo R2R : ${r2rType}\n\n`;
      }
      

      for (let i = 1; i < r2rInfo.length; i++) {
        const secondaryR2R = r2rInfo[1];

        if (secondaryR2R.r2rName) {
          message = `${message}Producto Destino ${i+1} : ${secondaryR2R.r2rName}\n`;
        }
        if (secondaryR2R.color) {
          message = `${message}Color ${i+1} : ${secondaryR2R.color}\n`;
        }
        if (secondaryR2R.poId) {
          message = `${message}ID Producto Destino ${i+1} : ${secondaryR2R.poId}\n`;
        }
        if (isNumber(secondaryR2R.price)) {
          message = `${message}Precio producto ${i+1} : ${secondaryR2R.price} €/mes\n`;
        }
        
        message = `${message}Operación comercial ${i+1} : ALTA\n`;
        message = `${message}Descripción del Producto ${i+1} : ${flowName}\n`;

        if(isPrePurchase !== undefined){
          message = `${message}Precompra ${i+1} : ${isPrePurchase ? `Si` : 'No'}\n`;
        }

        if (secondaryR2R.r2rType) {
          message = `${message}Tipo R2R ${i+1} : ${secondaryR2R.r2rType}\n\n`;
        }
      }
    } else {
      if (productName) {
        message = `${message}Producto Destino : ${productName}\n`;
      }
      if (color) {
        message = `${message}Color : ${color}\n`;
      }
      if (productOffering) {
        message = `${message}ID Producto Destino : ${productOffering}\n`;
      }
      if (promotion) {
        message = `${message}Promociones : ${promotion}\n`;
      }
      if (promotionName) {
        message = `${message} NOMBRE PROMO: ${promotionName}\n`;
      }
      if (isNumber(price)) {
        message = `${message}Precio producto : ${price} €${
          priceRecurring ? "/mes" : ""
        }\n`;
      }

      if (mainAction) {
        const { actionId, phoneNumber, iccNumber } = mainAction;
        if (actionId) {
          message = `${message}Operación comercial : ${getCQActionNameByCode(
            actionId
          )}\n`;
        }
        if (phoneNumber) {
          message = `${message}Número Teléfono : ${phoneNumber}\n`;
        }
        if (iccNumber) {
          message = `${message}ICC Prepago : ${iccNumber}\n`;
        }
      }
      if (flowName) {
        message = `${message}Descripción del Producto : ${flowName}\n`;
      }
      
      if(isPrePurchase !== undefined){
        message = `${message}Precompra : ${isPrePurchase ? `Si` : 'No'}\n`;
      }
    
      if (r2rType) {
        message = `${message}Tipo R2R : ${r2rType}${r2rSubType ? `-${r2rSubType}` : ''}\n`;
      }
    }

    if (secondarySelection && Array.isArray(secondarySelection)) {
      const landLineSelections = secondarySelection.filter(
        (selection) => selection.productType === PRODUCT_TYPES.LAND_LINE
      );
      let landLineSelectionsSection = "";
      landLineSelections.forEach((selection) => {
        const { actionId, customerQuoteItems } = selection;
        if (actionId) {
          landLineSelectionsSection = `${landLineSelectionsSection}Operación solicitada : ${getCQActionNameByCode(
            actionId
          )}\n`;
        }
        if (
          customerQuoteItems[0] &&
          customerQuoteItems[0].clientPhoneNumberToBeAppliedTo
        ) {
          landLineSelectionsSection = `${landLineSelectionsSection}Número Teléfono : ${customerQuoteItems[0].clientPhoneNumberToBeAppliedTo}\n`;
        }
      });
      if (landLineSelectionsSection) {
        message = `${message}${landLineSelectionsSection}`;
      }

      const mobileSelections = secondarySelection.filter(
        (selection) =>
          selection.productType === PRODUCT_TYPES.MOBILE ||
          selection.productType === PRODUCT_TYPES.ADDITIONAL_MOBILE
      );
      let mobileSelectionsSection = "";
      mobileSelections.forEach((selection) => {
        const { actionId, description, customerQuoteItems } = selection;

        if (actionId) {
          mobileSelectionsSection = `${mobileSelectionsSection}\nOperación solicitada : ${getCQActionNameByCode(
            actionId
          )}\n`;
        }
        if (description) {
          mobileSelectionsSection = `${mobileSelectionsSection}Descripción oferta solicitada : ${description}\n`;
        }
        if (
          customerQuoteItems[0] &&
          customerQuoteItems[0].clientPhoneNumberToBeAppliedTo
        ) {
          mobileSelectionsSection = `${mobileSelectionsSection}Número Teléfono : ${customerQuoteItems[0].clientPhoneNumberToBeAppliedTo}\n`;
        }
        if (customerQuoteItems[0] && customerQuoteItems[0].iccNumber) {
          mobileSelectionsSection = `${mobileSelectionsSection}ICC Prepago : ${customerQuoteItems[0].iccNumber}\n`;
        }
      });
      if (mobileSelectionsSection) {
        const mobileSelectionsTitle = ":::::::::::::BLOQUE MÓVIL:::::::::::::";
        message = `${message}${mobileSelectionsTitle}${mobileSelectionsSection}`;
      }
    }
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getShoppingCartProductTypeSection = (products, localizedStrings, forcedProductType = '', allDowngradeItems = false) => {
  let message = "";

  if(!products || !Array.isArray(products) || (Array.isArray(products) && products.length === 0)){
    return message;
  }

  if(forcedProductType){
    if(allDowngradeItems){
      message = `${message}:::::::::::: BAJAS DE ${forcedProductType} ::::::::::::\n`;
    } else {
      message = `${message}:::::::::::: INFORMACION VENTA ${forcedProductType} ::::::::::::\n`;
    }
  }
  products.forEach((poInfo, index) => {
    if (poInfo) {
      let prefix = poInfo.productType;
      if (
        poInfo.productType &&
        localizedStrings[
          STRING_KEYS.se.message.shoppingCart[poInfo.productType]
        ]
      ) {
        prefix =
          localizedStrings[
            STRING_KEYS.se.message.shoppingCart[poInfo.productType]
          ];
      }

      if(!forcedProductType){
        message = `${message}:::::::::::: INFORMACION VENTA ${prefix} ::::::::::::\n`;
      }
      if(poInfo.productOffering.id){
        message = `${message}${prefix} IDPO ${index+1}: ${poInfo.productOffering.id}\n`;
      }
      message = `${message}${prefix} NOMBRE ${index+1}: ${poInfo.productOffering.text}\n`;
      if (poInfo.promotionId) {
        message = `${message}${prefix} IDPROMO ${index+1}: ${poInfo.promotionId}\n`;
      }
      if (poInfo.promotionName) {
        message = `${message}${prefix} NOMBRE PROMO ${index+1}: ${poInfo.promotionName}\n`;
      }
      if (isNumber(poInfo.priceBeforeDiscounts)) {
        if(isNumber(poInfo.finalPrice)){
          message = `${message}${prefix} PRECIO CON PROMO ${index+1}: ${poInfo.finalPrice}\n`;
        }
        message = `${message}${prefix} PRECIO SIN PROMO ${index+1}: ${poInfo.priceBeforeDiscounts}\n`;
      } else if(isNumber(poInfo.finalPrice)){
        message = `${message}${prefix} PRECIO SIN PROMO ${index+1}: ${poInfo.finalPrice}\n`;
      }

      if (poInfo.productType === PRODUCT_TYPES.ADDITIONAL_MOBILE || poInfo.productType === PRODUCT_TYPES.MOBILE) {
        if (poInfo.actionId) {
          message = `${message}${prefix} OPERACIÓN MÓVIL ${index+1}: ${getCQActionNameByCode(
            poInfo.actionId
          )}\n`;
        }
        if (poInfo.clientPhoneNumberToBeAppliedTo) {
          message = `${message}${prefix} NÚMERO MÓVIL ${index+1}: ${poInfo.clientPhoneNumberToBeAppliedTo}\n`;
        }
      } else if (poInfo.productType === PRODUCT_TYPES.BAF) {
        if (poInfo.actionId) {
          message = `${message}${prefix} OPERACIÓN FIJO : ${getCQActionNameByCode(
            poInfo.actionId
          )}\n`;
        }
      } else {
        message = `${message}${prefix} OPERACIÓN ${index+1}: ${getCQActionNameByCode(
          poInfo.actionId
        )}\n`;
      }
      message = `${message}\n`;
    }
  });

  return message;
}

const getShoppingCartSection = (cartInfo, localizedStrings, netflixProductToAdd, additionalProductsToAdd) => {
  let message = "";

  if (cartInfo) {
    const { recurringCharges } = { ...cartInfo };

    const title = `::::::::::::: ${
      localizedStrings[STRING_KEYS.se.message.shoppingCart.title]
    } :::::::::::::\n`;
    if (
      recurringCharges &&
      recurringCharges.products &&
      Array.isArray(recurringCharges.products)
    ) {
      const filteredProducts = recurringCharges.products.filter(
        (product) => product.productType !== PRODUCT_TYPES.PACK && product.productType !== PRODUCT_TYPES.TV && product.productType !== PRODUCT_TYPES.NETFLIX
      );
      const filteredProductsMessage = getShoppingCartProductTypeSection(filteredProducts, localizedStrings);
      message = `${message}${filteredProductsMessage}\n`;

      const tvProducts = recurringCharges.products.filter(
        (product) => (product.productType === PRODUCT_TYPES.TV || product.productType === PRODUCT_TYPES.NETFLIX) && product.actionId !== CQ_ACTION_CODES.UNSUBSCRIBE
      );
      const tvProductsMessage = getShoppingCartProductTypeSection(tvProducts, localizedStrings, PRODUCT_TYPES.TV);
      message = `${message}${tvProductsMessage}\n`;
      
      const downgradedTVProducts = recurringCharges.products.filter(
        (product) => (product.productType === PRODUCT_TYPES.TV || product.productType === PRODUCT_TYPES.NETFLIX) && product.actionId === CQ_ACTION_CODES.UNSUBSCRIBE
      );
      const downgradedTVProductsMessage = getShoppingCartProductTypeSection(downgradedTVProducts, localizedStrings, PRODUCT_TYPES.TV, true);
      message = `${message}${downgradedTVProductsMessage}\n`;

      if(netflixProductToAdd) {
        const netflixParamsParts = netflixProductToAdd.split('_');
        let netflixObj = {
          productOffering: netflixParamsParts[0],
        };

        if(netflixParamsParts[1]=== CHARACTERISTIC_VALUES.NETFLIX.STANDARD){
          netflixObj.mode = 'NETFLIX STANDARD';
        } else if(netflixParamsParts[1]=== CHARACTERISTIC_VALUES.NETFLIX.PREMIUM){
          netflixObj.mode = 'NETFLIX PREMIUM';
        } else if(netflixParamsParts[1]=== CHARACTERISTIC_VALUES.NETFLIX.STANDARD_ADS){
          netflixObj.mode = 'NETFLIX STANDARD CON ANUNCIOS';
        }
        let prefix = PRODUCT_TYPES.NETFLIX;
          if (
            PRODUCT_TYPES.NETFLIX &&
            localizedStrings[
              STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.NETFLIX]
            ]
          ) {
            prefix =
              localizedStrings[
                STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.NETFLIX]
              ];
          }

          message = `${message}:::::::::::: INFORMACION VENTA ${prefix} ::::::::::::\n`;
          message = `${message}${prefix} IDPO : ${netflixObj.productOffering}\n`;
          message = `${message}${prefix} NOMBRE : ${netflixObj.mode}\n`;
          
          message = `${message}\n`;
      }
      if(additionalProductsToAdd) {
        const additionalProductsToAddSplitted = additionalProductsToAdd.split(';');

        let prefix = PRODUCT_TYPES.TV;
          if (
            PRODUCT_TYPES.TV &&
            localizedStrings[
              STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.TV]
            ]
          ) {
            prefix =
              localizedStrings[
                STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.TV]
              ];
          }
          additionalProductsToAddSplitted.forEach(additionalProduct =>{
            message = `${message}:::::::::::: INFORMACION VENTA ${prefix} ::::::::::::\n`;
            message = `${message}${prefix} IDPO : ${additionalProduct}\n`;
          })

          message = `${message}\n`;
      }
      if (message !== "") {
        message = `${title}${message}`;
      }
      if(isNumber(recurringCharges.groupPrice)){
        message = `${message}::::::::::::: INFORMACIÓN CARRO TOTAL :::::::::::::\n`;
  
        if (isNumber(recurringCharges?.groupPriceBeforeDiscounts)) {
          if(isNumber(recurringCharges.groupPrice)){
            message = `${message}PRECIO TOTAL CON PROMO: ${recurringCharges.groupPrice}\n`;
          }
          message = `${message}PRECIO TOTAL SIN PROMO: ${recurringCharges.groupPriceBeforeDiscounts}\n`;
        } else if(isNumber(recurringCharges.groupPrice)){
          message = `${message}PRECIO TOTAL SIN PROMO: ${recurringCharges.groupPrice}\n`;
        }
      }
    }
  }
  return message;
};

const getSelectedMobileLineSection = (selectedMobileLine) => {
  let message = "";
  if (selectedMobileLine) {
    const title = ":::::::::::::LINEA MOVIL:::::::::::::\n";
    message = `${message}Linea movil elegida : ${selectedMobileLine}\n`;
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getNationalitySection = (nationalityName) => {
  let message = "";
  if (nationalityName) {
    const title = ":::::::::::::NACIONALIDAD:::::::::::::\n";
    message = `${message}Nacionalidad : ${nationalityName}\n`;
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getInstallationSection = (installation, localizedStrings) => {
  let message = "";
  if (installation) {
    const title = ":::::::::::::INSTALACIÓN:::::::::::::\n";
    if (installation.type) {
      message = `${message}Tipo de instalación : ${
        localizedStrings[STRING_KEYS.se.message.installation[installation.type]]
      }\n`;
    }
    if (
      installation.address &&
      installation.type !== CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT &&
      installation.type !== CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID
    ) {
      message = `${message}Dirección de instalación : ${installation.address}\n`;
    }
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getPPIPSection = (ppip) => {
  let message = "";
  if (ppip) {
    const title = "::::::::::::: LÍNEA PROVISIONAL :::::::::::::\n";
    if (ppip.selection !== undefined) {
      message = `${message}Portabilidad con PPIP : ${
        ppip.selection ? "Sí" : "No"
      }\n`;
    }
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getSpeedSection = (speedId, localizedStrings) => {
  let message = "";
  if (speedId && localizedStrings[STRING_KEYS.se.message.speed[speedId]]) {
    const title = "::::::::::::: CAMBIO VELOCIDAD :::::::::::::\n";

    message = `${message}${
      localizedStrings[STRING_KEYS.se.message.speed.title]
    } : ${localizedStrings[STRING_KEYS.se.message.speed[speedId]]}\n`;
    
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getShippingSection = (shipping, localizedStrings) => {
  let message = "";
  if (shipping) {
    const title = "::::::::::::: ENVÍO :::::::::::::\n";
    if (shipping.type) {
      message = `${message}${
        localizedStrings[STRING_KEYS.se.message.shipping.type]
      } : ${
        localizedStrings[STRING_KEYS.se.message.shipping[shipping.type]]
      }\n`;
    }
    if (shipping.address) {
      message = `${message}${
        localizedStrings[STRING_KEYS.se.message.shipping.address]
      } : ${shipping.address}\n`;
    }
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getPaymentSection = (payment, localizedStrings) => {
  let message = "";
  if (payment) {
    const title = "::::::::::::: FORMA DE PAGO :::::::::::::\n";
    if (payment.accountNumber) {
      message = `${message}${
        localizedStrings[STRING_KEYS.se.message.payment.account]
      } : ${payment.accountNumber}\n`;
    }
    if (payment.customerAccountId) {
      message = `${message}${
        localizedStrings[STRING_KEYS.se.message.payment.customerAccountId]
      } : ${payment.customerAccountId}\n`;
    }
    if (!payment.accountNumber && !payment.customerAccountId && payment.sameAccount) {
      message = `${message}${
        localizedStrings[STRING_KEYS.se.message.payment.account]
      } : ${payment.sameAccount}\n`;
    }
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getTerminalSection = (info) => {
  let message = "";
  if (info) {
    const title = ":::::::::::::INFORMACIÓN VENTA DE TERMINAL:::::::::::::\n";
    if (info.mobileLine) {
      message = `${message}LINEA MOVIL FUSIÓN : ${info.mobileLine}\n`;
    }
    if (info.productOfferingName) {
      message = `${message}TERMINAL : ${info.productOfferingName} ${
        info.color ? `| ${info.color}` : ""
      } ${info.storage ? `| ${info.storage}` : ""}\n`;
    }
    if (info.productOffering) {
      message = `${message}TERMINAL PO : ${info.productOffering}\n`;
    }
    if (info.modality) {
      message = `${message}MODALITY : ${info.modality}\n`;
    }
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getR2RRenewalSection = (info) => {
  let message = "";
  if (info) {
    const title = ":::::::::::::INFORMACIÓN CANCELACIÓN R2R INCLUIDO:::::::::::::\n";

    if (info.productOfferingId) {
      message = `${message}ID PRODUCT OFFERING : ${info.productOfferingId}\n`;
    }
    if (info.productName) {
      message = `${message}NOMBRE TERMINAL: ${info.productName}\n`;
    }
    if (info.cancellationFee) {
      message = `${message}COSTE DE CANCELACIÓN ANTICIPADA : ${info.cancellationFee}\n`;
    }
    if (info.hasMobileInsurance) {
      message = `${message}TIENE SEGURO MOVIL : ${info.hasMobileInsurance ? 'SI' : 'NO'}\n`;
    }
    if (info.riskCode) {
      message = `${message}RESULTADO VALORACION RIESGO : ${info.riskCode} \n`;
    } else {
      message = `${message}RESULTADO VALORACION RIESGO : Desconocido\n`;
    }
    if (isNumber(info.monthlyCreditLimit)) {
      message = `${message}CREDITO MENSUAL DISPONIBLE : ${info.monthlyCreditLimit}\n`;
    } else {
      message = `${message}CREDITO MENSUAL DISPONIBLE : Desconocido\n`;
    }
    if (isNumber(info.creditLimit)) {
      message = `${message}CREDITO TOTAL DISPONIBLE : ${info.creditLimit}\n`;
    } else {
      message = `${message}CREDITO TOTAL DISPONIBLE : Desconocido\n`;
    }
    if (isNumber(info.pvpUntaxed)) {
      message = `${message}PVPR TOTAL SIN IMPUESTOS : ${info.pvpUntaxed}\n`;
    } else {
      message = `${message}PVPR TOTAL SIN IMPUESTOS : Desconocido\n`;
    }
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const getInsuranceTsSection = (tsInfo) => {
  let message = "";
  if (tsInfo) {
    const title = ":::::::::::::INFORMACIÓN TS:::::::::::::\n";
    message = `${message}INFO TS : `;
    if (tsInfo.docNumber) {
      message = `${message} ${tsInfo.docNumber} |`;
    }
    if (tsInfo.mobileLine) {
      message = `${message} ${tsInfo.mobileLine} |`;
    }
    if (tsInfo.contactEmail) {
      message = `${message} ${tsInfo.contactEmail} |`;
    }
    message = `${message} TRUE |`;
    if (tsInfo.selectedMobileInsuranceValue) {
      message = `${message} ${tsInfo.selectedMobileInsuranceValue} |`;
    }
    if (tsInfo.currentDateTime) {
      message = `${message} ${tsInfo.currentDateTime} |`;
    }
    if (tsInfo.productOffering) {
      message = `${message} ${tsInfo.productOffering} |`;
    }
    if (tsInfo.storageId) {
      message = `${message} ${tsInfo.storageId}`;
    }
    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
};

const convertTypeOfSimsToHumanReadable = (typeOfSimsArray) => {
  const newTypeOfSimsArray = [];

  typeOfSimsArray.forEach((typeOfSim) => {
    if (typeOfSim === CHARACTERISTIC_VALUES.SIM_TYPES.SIM) {
      newTypeOfSimsArray.push("SIM");
    } else if (typeOfSim === CHARACTERISTIC_VALUES.SIM_TYPES.E_SIM) {
      newTypeOfSimsArray.push("eSIM");
    } else {
      newTypeOfSimsArray.push(typeOfSim);
    }
  });

  return newTypeOfSimsArray;
}

const getMultisimSection = (info) => {
  let message = "";
  if (info) {
    const title = "\n:::::::::::::INFORMACIÓN MULTISIM:::::::::::::\n";
    if (info.numberOfSims) {
      message = `${message}NUMERO DE TARJETAS : ${info.numberOfSims}\n`;
    }
    if (info.typeOfSims) {
      const newTypeOfSimsArray = convertTypeOfSimsToHumanReadable(info.typeOfSims);
      message = `${message}TIPO DE TARJETAS : ${newTypeOfSimsArray}\n`;
    }

    if (message !== "") {
      message = `${title}${message}`;
    }
  }
  return message;
}

export const generateSEMessage = ({
  error,
  buyInfo,
  cartInfo,
  installation,
  ppip,
  shipping,
  payment,
  landLineSelections,
  terminalInfo,
  allPOsToBuy,
  localizedStrings,
  forceShoppingCartSection,
  netflixProductToAdd,
  additionalProductsToAdd,
  selectedMobileLine,
  nationalityName,
  r2rRenewal,
  multiSim,
  speedId,
  r2rInfo,
}) => {
  let message = "";

  message = `${message}${getErrorSection(error, localizedStrings)}`;
  message = `${message}${getProductSection(buyInfo, r2rInfo)}`;
  if (allPOsToBuy.length > 1 || forceShoppingCartSection || netflixProductToAdd || additionalProductsToAdd) {
    message = `${message}${getShoppingCartSection(
      cartInfo,
      localizedStrings,
      netflixProductToAdd,
      additionalProductsToAdd,
    )}`;
  }
  message = `${message}\n${getBundleLandLineSection(
    landLineSelections,
    installation,
    ppip
  )}`;
  message = `${message}${getSelectedMobileLineSection(
    selectedMobileLine
  )}`;
  message = `${message}${getNationalitySection(
    nationalityName
  )}`;
  if(!landLineSelections){
    message = `${message}${getInstallationSection(
      installation,
      localizedStrings
    )}`;
    message = `${message}${getPPIPSection(ppip)}`;
  }
  message = `${message}${getShippingSection(shipping, localizedStrings)}`;
  message = `${message}${getPaymentSection(payment, localizedStrings)}`;
  message = `${message}${getTerminalSection(terminalInfo)}`;
  if(r2rRenewal){
    message = `${message}${getR2RRenewalSection(r2rRenewal)}`;
  }
  if(speedId){
    message = `${message}${getSpeedSection(speedId, localizedStrings)}`;
  }

  if (multiSim?.numberOfSims && multiSim?.typeOfSims) {
    message = `${message}${getMultisimSection(multiSim)}`;
  }

  return message;
};

const getBundleProductSection = (bundleInfo) => {
  let message = "";
  const title = `::::::::::::: INFORMACION VENTA BUNDLE :::::::::::::\n`;
  if (bundleInfo && Array.isArray(bundleInfo)) {
    bundleInfo.forEach((bundleItem) => {
      const prefix = "BUNDLE ";
      message = `${message}${prefix}IDPO : ${bundleItem.productOffering.id}\n`;
      message = `${message}${prefix}NOMBRE : ${bundleItem.productOffering.text}\n`;
      if (bundleItem.promotionId) {
        message = `${message}${prefix}IDPROMO : ${bundleItem.promotionId}\n`;
      }
      if (bundleItem.promotionName) {
        message = `${message}${prefix}NOMBRE PROMO : ${bundleItem.promotionName}\n`;
      }
      message = `${message}${prefix}PRECIO FINAL : ${bundleItem.finalPrice}\n`;
      if (bundleItem.priceBeforeDiscounts) {
        message = `${message}${prefix}PRECIO ANTES DEL DESCUENTO : ${bundleItem.priceBeforeDiscounts}\n`;
      }
      message = `${message}\n`;
    });
  }
  if (message !== "") {
    message = `${title}${message}`;
  }

  return message;
};

const getBundleLandLineSection = (landLineSelections, installation, ppip) => {
  let message = "";

  const title = "::::::::::::: BLOQUE FIJO :::::::::::::\n";
  if (landLineSelections && Array.isArray(landLineSelections)) {
    landLineSelections.forEach((selection) => {
      const { actionId, phoneNumber } = selection;

      if (phoneNumber) {
        message = `${message}NÚMERO FIJO : ${phoneNumber}\n`;
      }
      if (actionId) {
        message = `${message}OPERACIÓN FIJO : ${getCQActionNameByCode(
          actionId
        )}\n`;
      }
      if (ppip && ppip.selection !== undefined) {
        message = `${message}Portabilidad con PPIP : ${
          ppip.selection ? "Sí" : "No"
        }\n`;
      }
      if (installation && installation.address) {
        message = `${message}DIRECCIÓN INSTALACIÓN : ${installation.address}\n`;
      }
    });
  }
  if (message !== "") {
    message = `${title}${message}`;
  }

  return message;
};
const getBundleMobileLineSection = (mobileLineSelections) => {
  let message = "";

  const title = "::::::::::::: BLOQUE MÓVIL :::::::::::::\n";
  if (mobileLineSelections && Array.isArray(mobileLineSelections)) {
    mobileLineSelections.forEach((selection) => {
      const {
        actionId,
        phoneNumber,
        description,
        productOfferingName,
        iccNumber,
      } = selection;

      if (actionId) {
        message = `${message}\nOPERACIÓN MÓVIL : ${getCQActionNameByCode(
          actionId
        )}\n`;
      }
      if (phoneNumber) {
        message = `${message}NÚMERO MÓVIL : ${phoneNumber}\n`;
      }
      if (productOfferingName) {
        message = `${message}PRODUCTO DESTINO : ${productOfferingName}\n`;
      }
      if (description) {
        message = `${message}Descripción oferta solicitada : ${description}\n`;
      }
      if (iccNumber) {
        message = `${message}ICC Prepago : ${iccNumber}\n`;
      }
    });
  }

  if (message !== "") {
    message = `${title}${message}`;
  }

  return message;
};

export const generateExtendedSEMessage = ({
  error,
  bundleInfo,
  landLineSelections,
  mobileLineSelections,
  cartInfo,
  installation,
  ppip,
  shipping,
  payment,
  localizedStrings,
  speedId,
}) => {
  let message = "";

  message = `${message}\n${getErrorSection(error, localizedStrings)}`;
  message = `${message}\n${getBundleProductSection(bundleInfo)}`;
  message = `${message}\n${getShoppingCartSection(cartInfo, localizedStrings)}`;
  message = `${message}\n${getBundleLandLineSection(
    landLineSelections,
    installation,
    ppip
  )}`;
  if(speedId){
    message = `${message}${getSpeedSection(speedId, localizedStrings)}`;
  }
  message = `${message}\n${getBundleMobileLineSection(mobileLineSelections)}`;
  message = `${message}\n${getShippingSection(shipping, localizedStrings)}`;
  message = `${message}\n${getPaymentSection(payment, localizedStrings)}`;

  return message;
};

export const generateImpersonationMessage = ({
  idPO,
  idPOAlt,
  idPOMessage,
}) => {
  const idPOMessageCompleted = idPOMessage
    .replace("{idPO}", idPO)
    .replace("{idPOAlt}", idPOAlt);

  return idPOMessageCompleted;
};

export const generateMobileInsuranceMessage = ({ terminalInfo, tsInfo }) => {
  let message = "";

  message = `${message}${getTerminalSection(terminalInfo)}`;
  message = `${message}${getInsuranceTsSection(tsInfo)}`;

  return message;
};
